/* eslint-disable import/prefer-default-export, react/prop-types */
import React from "react";
import Root from "@parallelpublicworks/gatsby-clf/src/Root";
import Site from "@parallelpublicworks/gatsby-clf/src/Site";

import { registerThemeComponents } from "@parallelpublicworks/clf-utils/componentRegistry";
export const wrapRootElement = ({ element }, options) => {
	return <Root options={options}>{element}</Root>;
};

export const wrapPageElement = ({ element, props }, options) => {
	return <Site element={element} props={props} options={options} />;
};

export const onServiceWorkerUpdateReady = () => {
	const answer = window.confirm(
		`This application has been updated. ` + `Reload to display the latest version?`
	);
	if (answer === true) {
		window.location.reload();
	}
};

export const onClientEntry = () => {
	registerThemeComponents();
};
